import { PaginaPublica, useTituloDaPagina } from "@/components/landing/layout-publico";

/**
 * /termos e /privacidade — PLACEHOLDER até a revisão jurídica.
 *
 * As rotas existem desde já porque o rodapé da landing aponta para elas: link de
 * Termos que dá 404 é pior que uma página dizendo que o texto está em revisão.
 * O texto final (e quem é o operador) entra num PR próprio.
 */
function DocumentoEmRevisao({ titulo }: { titulo: string }) {
  useTituloDaPagina(`${titulo} — Rizoma`);
  return (
    <PaginaPublica naLanding={false}>
      <section className="px-4 py-16 md:py-24">
        <div className="max-w-2xl mx-auto">
          <h1 className="font-titulo font-extrabold text-4xl md:text-5xl tracking-tight">{titulo}</h1>
          <p className="mt-6 text-lg text-muted-foreground" data-testid="documento-em-revisao">
            Em revisão — publicação em breve.
          </p>
        </div>
      </section>
    </PaginaPublica>
  );
}

export function TermosPage() {
  return <DocumentoEmRevisao titulo="Termos de uso" />;
}

export function PrivacidadePage() {
  return <DocumentoEmRevisao titulo="Política de privacidade" />;
}
